<template>
  <div id="contenedor-eliminar-documento-relacionado">
    <v-card>
      <v-card-title class="secondary--text"> Eliminar Archivo Relacionado </v-card-title>
      <v-card-text>
        <span class="secondary--text">
            ¿Desea eliminar el archivo {{this.documentoRelacionadoEliminar.descripcion}}?
        </span>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <custom-button
          @click="cerrar"
          tipo="formCancelar"
          label="Cancelar"
          class="mr-3"
        >
        </custom-button>
        <custom-button
          @click="mixEliminarDocumentoRelacionado"
          :disabled="enviandoFormulario"
          tipo="formAceptar"
          label="Eliminar"
        >
        </custom-button>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import mixEliminarDocumentoRelacionado from './mixDocumentosRelacionados';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EliminarDocumentoRelacionado',
  mixins: [mixEliminarDocumentoRelacionado],
  props: {
    documentoRelacionadoEliminar: {
      type: Object,
      required: true,
    },
    idReferenciaDocumentoRelacionado: {
      type: String,
      required: true,
    },
  },
  components: {
    CustomButton,
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      idReferencia: this.idReferenciaDocumentoRelacionado,
    };
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
  },
};
</script>

<style>
</style>
